import { render, staticRenderFns } from "./ModalProcessTabLogistics.vue?vue&type=template&id=58d6bf31&scoped=true"
import script from "./ModalProcessTabLogistics.vue?vue&type=script&lang=js"
export * from "./ModalProcessTabLogistics.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessTabLogistics.vue?vue&type=style&index=0&id=58d6bf31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d6bf31",
  null
  
)

export default component.exports